import { Outlet } from "react-router";

export default function CalculationsRoute() {
  return <Outlet />;
}
